import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Common } from '../../Assets/styles/common';

interface TextAreaProps {
    id?: string;
    value?: string;
    disabled?: boolean;
    onChange?: (value: string) => void;
    autoFocus?: boolean;
}

export const TextArea: React.SFC<TextAreaProps> = (props) => {
    const onChangeHandler = (e: React.ChangeEvent<HTMLTextAreaElement>) =>
        props.onChange ? props.onChange(e.target.value) : undefined;
    const { id, value, disabled, autoFocus } = props;
    return (
        <textarea
            id={id}
            className={css(styles.textArea, styles.textPseudo)}
            value={value}
            disabled={disabled}
            onChange={onChangeHandler}
            autoFocus={autoFocus}
        />
    );
};

const styles = StyleSheet.create({
    textArea: {
        minHeight: '80px',
        width: Common.Dimensions.controlWidth,
        minWidth: Common.Dimensions.minControlWidth,
        maxWidth: Common.Dimensions.maxControlWidth,
        font: Common.Font.normalText,
        fontStretch: 'normal',
        lineHeight: '1.43',
        letterSpacing: 'normal',
        color: '#292929',
        resize: 'vertical',
        border: Common.Borders.border,
        borderRadius: Common.Borders.radius,
        boxSizing: 'border-box',
        boxShadow: 'inset 0 1px 3px 0 rgba(0, 0, 0, 0.13)'
    },
    error: {
        border: 'solid 1px #fc4c5d',
        borderRadius: '4px 4px 0px 0px'
    },
    textPseudo: {
        ':hover': {
            boxShadow: Common.Borders.boxShadowHover,
        },
        ':focus': {
            boxShadow: '0 0 5px 0 #a2d3ff',
            border: 'solid 2px #54a5e5',
            outlineStyle: 'none',
        },
        ':disabled': Common.disabled,
    }
});
